var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCs = function SvgCs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.009 5.008A3.25 3.25 0 0 1 8.25 1.999h9A4.75 4.75 0 0 1 22 6.749v6a3.25 3.25 0 0 1-3.009 3.241A3.25 3.25 0 0 1 15.75 19h-5.083L7 21.749c-.824.618-2 .03-2-1v-1.76a3.25 3.25 0 0 1-3-3.24v-7.5a3.25 3.25 0 0 1 3.009-3.241Zm1.509-.009h9.232A3.25 3.25 0 0 1 19 8.249v6.232a1.75 1.75 0 0 0 1.5-1.732v-6a3.25 3.25 0 0 0-3.25-3.25h-9a1.75 1.75 0 0 0-1.732 1.5Zm-1.268 12.5H6.5v2.75l3.667-2.75h5.583a1.75 1.75 0 0 0 1.75-1.75v-7.5a1.75 1.75 0 0 0-1.75-1.75H5.25a1.75 1.75 0 0 0-1.75 1.75v7.5c0 .966.784 1.75 1.75 1.75Z",
    fill: "#666"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 11.999,
    r: 1,
    fill: "#666"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 11.999,
    r: 1,
    fill: "#666"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 11.999,
    r: 1,
    fill: "#666"
  })));
};
export default SvgCs;